export const APIRoutes = {
  apiAuthPreFlight: "/patient-centric-app-v2/auth/pf",
  apiGetDotPhrasesList: "/patient-centric-app-v2/dot-phrases/of_type",
  // mix panel error store
  apiMixPanelErrorStore: `/patient-centric-app-v2/mixpanel/log-error`,

  // User Signup:
  apiSignup: `/patient-centric-app-v2/admin/v3/users/complete-signup`,

  // User Agreement
  userAgreement: `/user-agreement/userAgreement`,
  getPatientsList: `/patient-centric-app-v2/clinic/patient_list`,

  // Clinics
  apiMyClinic: `/patient-centric-app-v2/clinic/my-clinic-slim`,
  apiMyClinicFull: `/patient-centric-app-v2/clinic/my-clinic`,
  apiUpdateFacilityInformation: `/patient-centric-app-v2/clinic/{clinic_id}/extra-info`,
  apiClinicConfig: `/patient-centric-app-v2/clinic/{clinic_id}/config`,
  apiClinicShiftReportConfig: `/patient-centric-app-v2/clinic/{clinic_id}/shift_report_config`,
  apiGetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiSetClinicFloor: `/patient-centric-app-v2/clinic/{clinic_id}/user-pref/floors`,
  apiPsnSettings: `/patient-centric-app-v2/clinic/{clinic_id}/psn_settings`,
  apiResidentList: `/patient-centric-app-v2/clinic/patient_list`,
  apiClinicDailyReportClinic: `/patient-centric-app-v2/v2/clinic_report`,

  // Alert
  apiGetAlertListNew: `/patient-centric-app-v2/clinic/{clinic_id}/v2/clinical-alerts`,
  apiGetAlertDetail: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v3/clinical-alerts/{alert_id}`,
  apiAddAlertComment: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/alert/{alert_id}`,
  apiGetPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/PSN/alert/{alert_id}`,
  apiAddPSNAck: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{alert_id}/ack`,
  apiGetCombinedAlertList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/escalated-flagged/v2`,
  apiGetFlagList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients/flagged`,
  apiAddAlertAck: `/patient-centric-app-v2/clinic/{clinic_id}/ack/alerts/v2`,
  apiPatientAlert: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/escalated-flagged/v2`,
  apiGetFlagAlertClinical: `/patient-centric-app-v2/clinic/{clinic_id}/clinical-listing`,
  apiHideFlag: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/alert/{flagged_id}/hide`,
  apiGetInboxFlagsByReviewStatus: `/patient-centric-app-v2/clinic/{clinic_id}/inbox/flags`,
  // Patient-centric flags API (coworker's new endpoint)
  apiGetPatientFlags: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/flags`,

  // Billing / Payers
  apiGetBillingPayers: `/patient-centric-app-v2/billing/payers`,
  apiCreateBillingPayer: `/patient-centric-app-v2/billing/payers`,
  apiUpdateBillingPayer: `/patient-centric-app-v2/billing/payers/{id}`,
  apiDeleteBillingPayer: `/patient-centric-app-v2/billing/payers/{id}`,

  // Billing / Providers
  apiGetBillingProviders: `/patient-centric-app-v2/billing/providers`,
  apiCreateBillingProvider: `/patient-centric-app-v2/billing/providers`,
  apiUpdateBillingProvider: `/patient-centric-app-v2/billing/providers/{id}`,
  apiDeleteBillingProvider: `/patient-centric-app-v2/billing/providers/{id}`,

  // Billing / Entity
  apiGetBillingEntity: `/patient-centric-app-v2/billing/entities`,
  apiCreateBillingEntity: `/patient-centric-app-v2/billing/entity`,
  apiUpdateBillingEntity: `/patient-centric-app-v2/billing/entity/{id}`,
  apiDeleteBillingEntity: `/patient-centric-app-v2/billing/entity/{id}`,

  // Billing / Roster
  apiGetBillingRosters: `/patient-centric-app-v2/billing/rosters`,
  apiCreateBillingRoster: `/patient-centric-app-v2/billing/rosters`,
  apiUpdateBillingRoster: `/patient-centric-app-v2/billing/rosters/{id}`,
  apiDeleteBillingRoster: `/patient-centric-app-v2/billing/rosters/{id}`,

  // Billing / Patients
  apiGetBillingPatients: `/patient-centric-app-v2/billing/patients`,
  apiCreateBillingPatient: `/patient-centric-app-v2/billing/patients`,
  apiUpdateBillingPatient: `/patient-centric-app-v2/billing/patients/{id}`,
  apiDeleteBillingPatient: `/patient-centric-app-v2/billing/patients/{id}`,

  // Billing / Charges
  apiGetBillingCharges: `/patient-centric-app-v2/billing/charges`,
  apiCreateBillingCharges: `/patient-centric-app-v2/billing/charges`,
  apiUpdateBillingCharges: `/patient-centric-app-v2/billing/charges/{id}`,
  apiDeleteBillingCharges: `/patient-centric-app-v2/billing/charges/{id}`,
  apiGetBillingChargesStatusSummary: `/patient-centric-app-v2/billing/charges/summary/status`,

  //Dashboard
  apiGetDashboardList: `/patient-centric-app-v2/clinic/{clinic_id}/cip/v2/psn-alerts`,
  apiGetPsnAlertGraphDataList: `/patient-centric-app-v2/clinic/{clinic_id}/patients/daily_rr_graph`,
  apiGetPatientListDashboard: `/patient-centric-app-v2/clinic/{clinic_id}/v2/recent/admissions`,
  apiGetReAdmitRadatMostCritical: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v2/readmit_radar/most-critical`,

  //s3
  apiGetFileFromS3: "/patient-centric-app-v2/aws/document",

  //support
  apiReportAProblem: `/patient-centric-app-v2/clinic/{clinic_id}/report-problem/cip/customer-support`,
  apiSubmitFeedback: `/patient-centric-app-v2/feedback/cip`,
  apiSubmitRating: `/patient-centric-app-v2/delighted/rating`,

  //push Notifications
  apiStoreToken: `/patient-centric-app-v2/v3/token`,
  apiGetNotificationSettings: `/patient-centric-app-v2/user/v4`,
  apiPutNotificationSettings: `/patient-centric-app-v2/user/preference/notification/v4`,
  apiNasaTlxPreference: `/patient-centric-app-v2/user/preference/nasa-tlx`,

  //SMS
  apiSendOTP: `/patient-centric-app-v2/twilio/send-otp`,
  apiVerifyOTP: `/patient-centric-app-v2/verify-otp`,
  apiGetPortalUserInfo: `/patient-centric-app-v2/user_info`,
  apiSavePhoneNumber: `/patient-centric-app-v2/user_info/user_phone_number`,

  //report
  apiGetClinicalReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports`,
  apiGetDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}`,
  apiAddReadDailyReport: `/patient-centric-app-v2/clinic/{clinic_id}/daily_reports/{daily_report_id}/read`,
  // report - AI risk report
  apiGetRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/v4/gpt/{date}`,
  apiGetReadmitRadar: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/readmit_radar/v4`,
  apiGetRiskReportClinicPreference: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportList: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list/v2`,
  apiAckRiskReport: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}`,

  // report - AI risk report public routes
  apiGetRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/link/summaries`,
  apiGetReadmitRadarPublicRoute: `/patient-centric-app-v2/idt_reports/link/readmit_radar`,
  apiGetRiskReportClinicPreferencePublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/gpt/clinic_preference`,
  apiGetRiskReportListPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/list-`,
  apiAckRiskReportPublicRoute: `/patient-centric-app-v2/idt_reports/clinic/{clinic_id}/ack/idt_report/{idt_report_id}-`,

  //patient
  apiCreatePatient: `/patient-centric-app-v2/patient`,
  apiGetPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/patients`,
  apiGetPatientEventList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v5/events`,
  apiGetPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/v4/patient-chart-summary`,
  apiGetPatientCircadiaVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-circadia-vitals`,
  apiGetPatientPCCVital: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/last-pcc-vitals`,
  apiGetPatientRespRate: `/patient-centric-app-v2/clinic/{clinic_id}/patients/rr-metrics-psn`,
  apiGetPatientVitalGraph: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/pcc-vitals-history`,
  apiGetPatientRRGraph: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/rr_graph`,
  apiGetPatientNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/cip/combined-circadia-notes`,
  apiGetPatientPCCNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/pcc-notes`,
  apiAddPatientNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{resident_id}/v2/notes`,
  // search
  apiGetSearch: `/patient-centric-app-v2/clinic/{clinic_id}/v3/patients`,

  apiGetAllPatientList: `/patient-centric-app-v2/clinic/{clinic_id}/resident/listing`,

  // Get all patients list (room assigned and not assigned) - V2 API
  apiGetAllPatientListV2: `/patient-centric-app-v2/clinic/{clinic_id}/v2/resident/listing`,

  // device
  apiOfflineDevice: "/patient-centric-app-v2/clinic/{clinic_id}/device/offline",
  // apiAllDevice: "/patient-centric-app/clinic/device/status",
  apiAllDevice: "/patient-centric-app-v2/clinic/{clinic_id}/devices",

  //insights
  apiGetTOCAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOC/allowed_months",
  apiGetTOPAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/TOP/allowed_months",
  apiGetDischargeAllowedMonths:
    "/patient-centric-app-v2/clinic/{clinic_id}/discharge_insights/allowed_months",
  apiGetTOC: "/patient-centric-app-v2/clinic/{clinic_id}/v2/TOC",
  apiGetTOP: "/patient-centric-app-v2/clinic/{clinic_id}/TOP",
  apiGetDischarge:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/discharge_insights",
  apiGetTOCRootCause:
    "/patient-centric-app-v2/clinic/{clinic_id}/transfer_out/{TO_EVENT_ID}/RCA",

  // Outcomes
  apiGetOutcomesFacilities:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/facilities",
  apiGetOutcomesAvailablePeriods:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/available_periods",
  apiGetOutcomesTimeSeries:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/time_series",
  apiGetOutcomesFilterOptions:
    "/patient-centric-app-v2/clinic/{clinic_id}/outcomes/filter_options",

  //watchlist
  apiGetWatchlist: `/patient-centric-app-v2/clinic/{clinic_id}/my/watchlist/v2/patients/details`,
  apiPutWatchlist: `/patient-centric-app-v2/clinic/{clinic_id}/my/watchlist/change`,

  //consent
  apiGetConsentList: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/consent_listing`,
  apiGetConsentDischargeList: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/v2/discharge/all_resident`,
  apiPostConsentChange: `/patient-centric-app-v2/clinic/{clinic_id}/consent-email-ledger/v4/change`,

  //CDL Endpoints
  apiPatientGraphData: `/circadia-vitals/patient_processed/{patient_id}/`,
  apiPatientGraphDataV2: `/v2/circadia-vitals/patient_processed/`,
  // Intercom
  apiGetUserHmac: "/patient-centric-app-v2/user/intercom/token",

  // Circadia IQ
  apiGenerateCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}",
  apiGetCircadiaIQ:
    "/patient-centric-app-v2/circadia_iq/v4/{clinic_id}/patient/{patient_id}/db",

  // bed exits
  apiAddBedExits: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiAddBedExitsV3: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exit/settings/v3`,
  apiUpdateBedExitsTime: `/patient-centric-app-v2/user/bed-exit/settings/time`,
  apiUpdateBedExits: `/patient-centric-app-v2/user/bed-exit/settings/toggle/v3`,
  apiGetBedExitSettingsByUserPref: `/patient-centric-app-v2/clinic/{clinic_id}/user/bed-exits/v2`,
  apiGetPatientNotificationSettings: `/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/bed-exits/v2`,
  apiGetDiagnoses:
    "/patient-centric-app-v2/clinic/{clinic_id}/resident/{resident_id}/patient-diagnosis",
  apiUpdatePatientNotificationSettings: `/patient-centric-app-v2/user/bed-exit/settings/v2`,
  apiUpdatePatientNotificationSettingsV2: `/patient-centric-app-v2/user/bed-exit/settings/v3`,
  apiUpdateCombineBedExits: `/patient-centric-app-v2/user/bed-exit/settings/combine`,

  // Bed Exit Event List
  apiGetBedExitEventList:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/bed-exit-events",

  apiGetBedExitFacilityReport:
    "/patient-centric-app-v2/clinic/{clinic_id}/bed-exit-comparison",

  // Users
  apiUserBetaFeature: `/patient-centric-app-v2/user/beta-feature`,
  apiAutoBedExit: `/patient-centric-app-v2/user/auto-bed-exit`,

  // Tracking
  apiTracking: `/`,

  // Summary
  apiGetSummary: `/patient-centric-app-v2/clinic/{clinic_id}/v4/alerts/summary`,

  // IPV
  apiGetIPVNotesList: `/patient-centric-app-v2/clinic/{clinic_id}/v2/ipv_notes?status={status}`,
  apiAddIPVNotesAck: `/patient-centric-app-v2/clinic/{clinic_id}/acknowledge/ipv_note/{note_id}`,

  // Device Issues
  apiPostDeviceIssue: `/patient-centric-app-v2/clinic/{clinic_id}/device-issues`,

  // Home Health apis
  apiGetSinglePatientInfo: "/home_health/patient/{patient_id}",
  apiGetPatientGraphData: "/home_health/patient/{patient_id}/readings",
  apiGetSelectedFacilityPatientList: "/home_health/facility/{clinic_id}/",
  // User Info
  apiUpdateUserInfo: `/patient-centric-app-v2/user/v2/name`,

  // Sales
  apiAddSalesAck: `/patient-centric-app-v2/clinic/{clinic_id}/demo-request`,

  // RT Blogger
  apiPostParseRTAR: `/pcc_blogger/clinic/{clinic_id}/parse_pdf`,
  apiPostRTARBilling: `/pcc_blogger/clinic/{clinic_id}/patient/{patient_id}/generate_billing/{month}/{year}`,
  apiGetBillingSettings: `/pcc_blogger/rt-billing/clinic/{clinic_id}/settings`,
  apiUpdateBillingSettings: `/pcc_blogger/rt-billing/clinic/{clinic_id}/settings`,
  apiGetServices: `/pcc_blogger/rt-billing/services`,
  apiUpdateServices: `/pcc_blogger/rt-billing/services`,
  apiGetAudit: `/pcc_blogger/rt-billing/clinic/{clinic_id}/audit_settings`,
  apiUpdateAudit: `/pcc_blogger/rt-billing/clinic/{clinic_id}/audit_settings`,
  apiGetCPTTypes: `/pcc_blogger/rt-billing/cpt-types`,
  apiPutBillingServiceStatus: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-service-logs`,
  apiGetOverviewPatients: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-service-logs/{month}/{year}`,
  apiGetBillingCycle: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-cycles`,
  apiGetBillingCycleForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-service-logs/{month}/{year}`,
  apiDeleteBillingCycle: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-cycles/{month}/{year}`,
  apiPutBillingCycleStatusForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-cycles/{month}/{year}`,
  apiDeleteBillingCycleForPatient: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/billing-cycles/{month}/{year}`,
  apiPostBillingFiles: `/pcc_blogger/rt-billing/clinic/{clinic_id}/billing-files`,
  apiPostFixError: `/pcc_blogger/rt-billing/clinic/{clinic_id}/patient/{patient_id}/fix-errors`,

  // VitalSync
  apiExtractVitals: `/patient-centric-app-v2/clinic/{clinic_id}/extract-vitals`,
  apiSubmitVitalsToPCC: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submit`,
  apiGetPCCSubmissionStatistics: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submission/statistics`,
  apiGetPCCQueueList: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/queue/list`,
  apiGetPCCQueueStatus: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/queue/status`,
  apiGetPCCSubmissionHistory: `/patient-centric-app-v2/clinic/{clinic_id}/pcc/submission/history`,
  apiGetNeedReviewVitals: `/patient-centric-app-v2/admin/v4/clinics/{clinic_id}/need-review-vitals`,
  apiUpdateNeedReviewVitals: `/patient-centric-app-v2/admin/v4/clinics/{clinic_id}/need-review-vitals`,

  // Enrolment
  apiGetEnrolledPatients: `/pcc_blogger/clinic/{clinic_id}/patients`,
  apiGetPreviouslyEnrolledPatients: `/rtx/patients/status_base_list/{clinic_id}`,
  apiGetPatientEligibility: `/patient-centric-app-v2/patient-eligibility/{patient_id}`,
  apiPutEnrollPatient: `/pcc_blogger/enrolment/new/{admission_id}`,
  apiPutExtendEnrollPatient: `/pcc_blogger/enrolment/update/{rtx_enrolment_id}`,

  // Billing Reports
  apiGetBillingReports: `/pcc_blogger/rt-billing/clinic/{clinic_id}/reports`,
  apiUpdateBillingReportCollectedAmount: `/pcc_blogger/rt-billing/clinic/{clinic_id}/update_collections/{month}/{year}`,

  // PSN v2 Review
  apiPutPSNAcknowledge: `/patient-centric-app-v2/clinic/{clinic_id}/psn_v2/shift_report/{notification_uuid}/ack`,

  apiPostAppPerformanceSurvey: `/patient-centric-app-v2/delighted/nps`,

  // Column Preferences
  apiGetColumnPreferences: `/patient-centric-app-v2/user-preferences/column-preferences`,
  apiPutColumnPreferences: `/patient-centric-app-v2/user-preferences/column-preferences`,
  apiPostColumnPreferencePreset: `/patient-centric-app-v2/user-preferences/column-preferences/presets`,
  apiPutColumnPreferencePreset: `/patient-centric-app-v2/user-preferences/column-preferences/presets/{preset_id}`,
  apiDeleteColumnPreferencePreset: `/patient-centric-app-v2/user-preferences/column-preferences/presets/{preset_id}`,
  apiApplyColumnPreferencePreset: `/patient-centric-app-v2/user-preferences/column-preferences/presets/{preset_id}/apply`,
  apiGetFacilities: "/patient-centric-app-v2/clinics",
  apiGetFacilitiesV2: "/patient-centric-app-v2/v2/clinics",
  apiGetAllFacilities: "/patient-centric-app-v2/admin/clinics",

  apiAssignFacility: "/patient-centric-app-v2/users/{userId}/clinics",
  apiProvisionCompassusClinics:
    "/patient-centric-app-v2/clinics/provision-compassus",

  // HealthScribe APIs - V1 (Legacy - kept for backward compatibility)
  healthScribeTranscriptionList: `/patient-centric-app-v2/healthscribe/transcription/list`,
  healthScribeGetSession: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/session/{session_id}`,
  healthScribeListSessions: `/patient-centric-app-v2/healthscribe/recording/clinic/{clinic_id}/sessions`,
  healthScribeS3UploadInit: `/patient-centric-app-v2/healthscribe/s3/upload/init`,
  healthScribeS3UploadPart: `/patient-centric-app-v2/healthscribe/s3/upload/part`,
  healthScribeS3UploadComplete: `/patient-centric-app-v2/healthscribe/s3/upload/complete`,
  healthScribeS3UploadCompleteAudio: `/patient-centric-app-v2/healthscribe/s3/upload/audio`,
  healthScribeS3UploadAbort: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/{session_id}/{upload_id}`,
  healthScribeS3UploadStatus: `/patient-centric-app-v2/healthscribe/s3/clinic/{clinic_id}/upload/status/{session_id}/{upload_id}`,

  // HealthScribe APIs - V2 (Multi-Segment with Pause/Resume)
  healthScribeV2StartRecording: `/patient-centric-app-v2/healthscribe/v2/recording/start`,
  healthScribeV2StopRecording: `/patient-centric-app-v2/healthscribe/v2/recording/stop`,
  healthScribeV2TranscriptionBatchSave: `/patient-centric-app-v2/healthscribe/v2/transcription/batch-save`,
  healthScribeV2NarrativeGenerate: `/patient-centric-app-v2/healthscribe/v2/narrative/generate`,
  healthScribeV2SessionComplete: `/patient-centric-app-v2/healthscribe/v2/session/complete`,
  healthScribeV2GetSession: `/patient-centric-app-v2/healthscribe/v2/session/{session_id}`,
  healthScribeV2ListSegments: `/patient-centric-app-v2/healthscribe/v2/session/{session_id}/segments`,
  healthScribeV2ListSessions: `/patient-centric-app-v2/healthscribe/v2/clinic/{clinic_id}/sessions`,

  // HealthScribe APIs - Heidi STT Integration (replaces WebSocket streaming)
  healthScribeHeidiTranscribe: `/patient-centric-app-v2/healthscribe/heidi/transcribe/{session_id}`,
  healthScribeHeidiTranscript: `/patient-centric-app-v2/healthscribe/heidi/transcript/{session_id}`,
  healthScribeHeidiRecover: `/patient-centric-app-v2/healthscribe/heidi/recover`,
  healthScribeHeidiAppendTranscript: `/patient-centric-app-v2/healthscribe/heidi/append-transcript/{session_id}`,
  // Combined transcribe + generate endpoint (async background processing)
  healthScribeHeidiTranscribeAndGenerate: `/patient-centric-app-v2/healthscribe/heidi/transcribe-and-generate/{session_id}`,
  healthScribeHeidiTranscribeAndGenerateResult: `/patient-centric-app-v2/healthscribe/heidi/transcribe-and-generate/result/{session_id}`,

  // Initial Patient Visit (IPV)
  apiGetIPVNotesByClinicID: `/patient-centric-app-v2/clinic/{clinic_id}/ipv_notes?status={status}`,
  apiGetIPVNotesByClinicIDv3: `/patient-centric-app-v2/clinic/{clinic_id}/v3/ipv_notes`,
  apiGetIPVNotesPatientsList: `/patient-centric-app-v2/clinic/{clinic_id}/v3/patients/ipv_notes`,
  apiPostIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiPostPatientExtraInfo: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/extra-info`,
  apiGetIPVNotesByPatientID: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes`,
  apiDeleteIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,
  apiGetPatientsForNavigator: `/patient-centric-app-v2/clinic/{clinic_id}/navigator/patients`,
  apiGetNavigatorPatientById: `/patient-centric-app-v2/clinic/{clinic_id}/navigator/patients/{patient_id}`,
  apiPatchNavigatorIpvIneligible: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/admissions/{admission_id}/navigator-ipv-ineligible`,
  apiGetEstimatedIpvTodoCount: `/patient-centric-app-v2/navigator/estimated-ipv-todo-count`,
  apiGetClinicsWithShifts: `/patient-centric-app-v2/navigator/clinics-with-shifts`,
  apiGetPatientVisitNotes: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes`,
  apiGetAtRiskReviewLockStatus: `/patient-centric-app-v2/clinic/{clinic_id}/at-risk-review-lock-status`,
  apiPostAtRiskReviewOverrideRequest: `/patient-centric-app-v2/clinic/{clinic_id}/at-risk-review-request`,
  apiPatchAtRiskReviewOverrideRequest: `/patient-centric-app-v2/clinic/{clinic_id}/at-risk-review-request`,

  // Navigator Custom Todos
  apiPostCustomTodo: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-todo`,
  apiPatchCustomTodo: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-todo/{todo_id}`,
  apiDeleteCustomTodo: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-todo/{todo_id}`,
  apiGetCustomTodoVisits: `/patient-centric-app-v2/clinic/{clinic_id}/navigator/custom-todo-visits`,
  apiGetClinicCustomTodoRecurrences: `/patient-centric-app-v2/clinic/{clinic_id}/navigator/custom-todo-recurrences`,
  apiCustomTodoRecurrence: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-todo-recurrence`,
  apiCustomTodoRecurrenceById: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-todo-recurrence/{schedule_id}`,

  // Patient Notes History (for history drawer in editor)
  apiGetPatientNotesHistory: `/patient-centric-app-v2/patient/{patient_id}/notes`,

  apiPutIPVNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ipv_notes/{ipv_note_id}`,
  apiDeleteIPVDraftAndSession: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/recording-draft`,

  // HPI Template APIs
  apiGetHPITemplates: `/patient-centric-app-v2/HPI/template/list`,
  apiCreateHPITemplate: `/patient-centric-app-v2/HPI/template/create`,
  apiGetSingleHPITemplate: `/patient-centric-app-v2/HPI/template/{template_id}`,
  apiUpdateHPITemplate: `/patient-centric-app-v2/HPI/template/update`,
  apiDeleteHPITemplate: `/patient-centric-app-v2/HPI/template/delete/{template_id}`,

  // Unified Visit Notes API (CREATE and UPDATE only - draft loading still uses legacy IPV API)
  apiCreateVisitNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes`,
  apiUpdateVisitNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/visit-notes/{note_id}`,
  apiGetAllVisitNotes: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes`,
  // Web list view variant — scopes patients via clinic_patient_admission so a
  // transferred patient's historical notes still appear under the old clinic.
  // Same query params and response shape as apiGetAllVisitNotes. Mobile clients
  // should keep using apiGetAllVisitNotes (lighter scoping, optimized for polling).
  apiGetAllVisitNotesFull: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/full`,
  apiGetVisitNoteProviders: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/providers`,
  apiSearchVisitNotes: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/search`,
  apiGetArchivedVisitNotes: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/archived`,
  apiRestoreArchivedVisitNote: `/patient-centric-app-v2/clinic/{clinic_id}/ipv_notes/{ipv_note_id}/restore`,
  apiGetSingleVisitNote: `/patient-centric-app-v2/visit-notes/{note_id}`,
  apiGetNoteLlmOutput: `/patient-centric-app-v2/healthscribe/heidi/note/{note_id}/llm-output`,
  apiDeleteNoteManualEditsHistory: `/patient-centric-app-v2/healthscribe/heidi/note/{note_id}/manual-edits-history`,

  // Summarize Narrative (for sharing as PDF)
  apiSummarizeNarrative: `/patient-centric-app-v2/healthscribe/heidi/summarize-narrative`,

  // Send Visit Note via eFax
  apiSendVisitNoteEfax: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/efax`,
  apiDownloadPartnershipSummaryDocx: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/partnership-summary/docx`,

  apiStorePreChartNote: `/patient-centric-app-v2/clinic/{clinic_id}/pre-chart-note`,

  // Twilio Visit Reminder
  apiSendVisitReminder: `/patient-centric-app-v2/twilio/send-visit-reminder`,

  // Discharge PDF APIs
  apiUploadDischargePdf:
    "/patient-centric-app-v2/clinic/{clinic_id}/medication-reconciliation/discharge-pdf/upload",
  apiGetDischargePdfUploads:
    "/patient-centric-app-v2/clinic/{clinic_id}/medication-reconciliation/discharge-pdf/uploads",
  apiGetMedRecAdmissions:
    "/patient-centric-app-v2/clinic/{clinic_id}/v2/medication-reconciliation/admissions",
  apiUpdateFindingStatus:
    "/patient-centric-app-v2/clinic/{clinic_id}/medication-reconciliation/discharge-pdf/upload/{upload_id}/findings/{finding_index}/status",

  // Side Peek Profile APIs
  apiGetSidePeekProfile: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/sidepeek-profile`,
  apiGenerateSidePeekProfile: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/sidepeek-profile`,
  apiUpdateSidePeekProfile: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/sidepeek-profile`,

  // Safety Note APIs
  apiGetSafetyNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/safety-note`,
  apiUpdateSafetyNote: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/safety-note`,

  // Code Status APIs
  apiGetCodeStatus: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/code-status`,
  apiUpdateCodeStatus: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/code-status`,

  // EHR Records APIs
  apiGetEhrMedications: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/medications`,
  apiGetEhrNutrition: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/nutrition`,
  apiGetEhrAssessments: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/assessments`,
  apiGetEhrAllergies: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/allergies`,
  apiGetEhrLabs: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/labs`,
  apiDownloadEHRLabs: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/ehr/labs/{lab_id}/download`,
  // v2 Assessments APIs pulling directly from PCC
  apiGetEhrAssessmentsV2: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/pcc/assessments`,
  apiGetEhrAssessmentsByAssessmentID: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/pcc/assessments/{assessment_id}`,
  // Care plan APIs pulling directly from PCC
  apiGetCarePlan: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/pcc/care-plans`,
  apiGetCarePlanFocusesByFocusIds: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/pcc/focuses`,
  // SSO Token Refresh
  apiSsoRefreshToken: `/patient-centric-app-v2/auth/sso/refresh`,

  // Patient Contacts APIs
  apiGetPatientContacts: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/contacts`,
  apiUpdatePatientContacts: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/contacts`,

  // Next Visit Plan APIs (kept for reference, superseded by Patient Summary)
  apiGetNextVisitPlan: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/next-visit-plan`,
  apiUpdateNextVisitPlan: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/next-visit-plan`,

  // Patient Summary APIs (sidepeek)
  apiGetSidePeekPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/patient-summary`,
  apiGenerateSidePeekPatientSummary: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/patient-summary`,

  // Geo
  apiValidateAddress: `/patient-centric-app-v2/geo/validate-address`,
  apiAddressSuggestions: `/patient-centric-app-v2/geo/address-suggestions`,
  apiComputeDistances: `/patient-centric-app-v2/geo/compute-distances`,
  apiGetHomeAddress: `/patient-centric-app-v2/geo/home-address`,
  apiSetHomeAddress: `/patient-centric-app-v2/geo/home-address`,

  // NP Scheduling
  apiNpSchedulingShifts: `/patient-centric-app-v2/np-scheduling/shifts`,
  // Per-diem availability lock-in. Backed by `committed_days.py` in
  // Patient-Centric-App-V2; supports `?viewall=true` for the admin tab's
  // monthly projection.
  apiNpSchedulingCommittedDays: `/patient-centric-app-v2/np-scheduling/committed-days`,

  // Temp Download (for Android WebView PDF downloads)
  apiTempDownloadUpload: `/patient-centric-app-v2/clinic/{clinic_id}/visit-notes/temp-download/upload`,

  // Compassus Navigator
  apiCompassusNavigator: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator`,
  apiCompassusNavigatorExport: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/export`,
  apiCompassusNavigatorCounts: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/counts`,
  apiCompassusNavigatorFilterPayers: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/payers`,
  apiCompassusNavigatorFilterMedications: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/medications`,
  apiCompassusNavigatorFilterAllergies: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/allergies`,
  apiCompassusNavigatorFilterConditions: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/conditions`,
  apiCompassusNavigatorFilterLastVisitProviders: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/last-visit-providers`,
  apiCompassusNavigatorFilterTodoTags: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/todo-tags`,
  apiCompassusNavigatorFilterCustomTags: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/custom-tags`,
  apiCompassusNavigatorFilterClinicalRiskScores: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/clinical-risk-scores`,
  apiCompassusNavigatorFilterNextVisitProviders: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/next-visit-providers`,
  apiCompassusNavigatorPatientTodo: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/todo`,
  apiCompassusNavigatorPatientTodoBulk: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/todo/bulk`,
  apiCompassusPatientCustomTags: `/patient-centric-app-v2/clinic/{clinic_id}/patient/{patient_id}/custom-tags`,
  apiCompassusPatientAssociations: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patient-associations/{patient_id}`,
  // Per-patient trend endpoints. Each returns the full chronological history
  // (newest-first, one entry per source visit, no roll-up) for a single
  // field extracted by the Compassus assessment pipeline. Latest values are
  // also hydrated inline on every /navigator list row via
  // `latest_acuity_*` / `latest_prognosis_*` / `latest_form_*`, so most call
  // sites use those directly and only reach for these endpoints when drawing
  // a trend or detail view on the patient profile.
  apiCompassusNavigatorPatientAcuityLevels: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/patient/{patient_id}/acuity-levels`,
  apiCompassusNavigatorPatientPrognoses: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/patient/{patient_id}/prognoses`,
  apiCompassusNavigatorPatientForms: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/patient/{patient_id}/forms`,
  // Structural schema for every Compassus assessment form. Pure projection
  // of the pipeline templates — body is identical for every clinic, and
  // only changes on code deploy. Safe to cache indefinitely on the client
  // (see useSWRImmutable on the FormTrendCard). Scoped under clinic_id
  // only to keep auth consistent with the other navigator endpoints.
  apiCompassusNavigatorFormsSchema: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/forms/schema`,
  apiCompassusNavigatorFilterAcuityLevels: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/navigator/filters/acuity-levels`,

  // Coordination Notes
  apiCoordNotes: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/coord-notes`,
  apiCoordNote: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/coord-notes/{note_id}`,
  // Compassus Care Plan
  apiCompassusCarePlan: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan`,
  apiCompassusCarePlanVersions: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan/versions`,
  apiCompassusCarePlanVersion: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan/versions/{version_id}`,
  apiCompassusCarePlanVersionDiff: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan/versions/{version_id}/diff`,
  apiCompassusCarePlanVersionRestore: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan/versions/{version_id}/restore`,
  apiCompassusCarePlanExport: `/patient-centric-app-v2/clinic/{clinic_id}/compassus/patients/{patient_id}/care-plan/export`,

  // Neo agent - conversations
  apiNeoConversations: `/patient-centric-app-v2/neo/conversations`,
  apiNeoConversation: `/patient-centric-app-v2/neo/conversations/{conversation_id}`,
  apiNeoConversationScope: `/patient-centric-app-v2/neo/conversations/{conversation_id}/scope`,
  apiNeoConversationScopeHistory: `/patient-centric-app-v2/neo/conversations/{conversation_id}/scope-history`,
  apiNeoConversationFork: `/patient-centric-app-v2/neo/conversations/{conversation_id}/fork`,
  apiNeoConversationBump: `/patient-centric-app-v2/neo/conversations/{conversation_id}/bump-last-message-at`,
  apiNeoConversationTurn: `/patient-centric-app-v2/neo/conversations/{conversation_id}/turn`,
  apiNeoConversationTurnStream: `/patient-centric-app-v2/neo/conversations/{conversation_id}/turn/stream`,

  // Neo agent - messages
  apiNeoMessages: `/patient-centric-app-v2/neo/conversations/{conversation_id}/messages`,
  apiNeoMessageUser: `/patient-centric-app-v2/neo/conversations/{conversation_id}/messages/user`,
  apiNeoMessageAssistantPending: `/patient-centric-app-v2/neo/conversations/{conversation_id}/messages/assistant-pending`,
  apiNeoMessageToolResult: `/patient-centric-app-v2/neo/conversations/{conversation_id}/messages/tool-result`,
  apiNeoMessage: `/patient-centric-app-v2/neo/messages/{message_id}`,
  apiNeoMessageInflight: `/patient-centric-app-v2/neo/messages/inflight`,
  apiNeoMessageMarkStreaming: `/patient-centric-app-v2/neo/messages/{message_id}/mark-streaming`,
  apiNeoMessageOverwriteContent: `/patient-centric-app-v2/neo/messages/{message_id}/overwrite-content`,
  apiNeoMessageComplete: `/patient-centric-app-v2/neo/messages/{message_id}/complete`,
  apiNeoMessageFail: `/patient-centric-app-v2/neo/messages/{message_id}/fail`,
  apiNeoMessageCancel: `/patient-centric-app-v2/neo/messages/{message_id}/cancel`,

  // Neo agent - tool calls
  apiNeoAssistantToolCalls: `/patient-centric-app-v2/neo/messages/{assistant_message_id}/tool-calls`,
  apiNeoAssistantToolCallsValidate: `/patient-centric-app-v2/neo/messages/{assistant_message_id}/tool-calls/validate-depends-on`,
  apiNeoConversationToolCalls: `/patient-centric-app-v2/neo/conversations/{conversation_id}/tool-calls`,
  apiNeoToolCallRunning: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/mark-running`,
  apiNeoToolCallComplete: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/complete`,
  apiNeoToolCallFail: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/fail`,
  apiNeoToolCallCancel: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/cancel`,
  apiNeoToolCallSkip: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/skip`,
  apiNeoToolCallResultLink: `/patient-centric-app-v2/neo/tool-calls/{tool_call_row_id}/result-message`,

  // Neo agent - documents (server-side rendering). Two sibling
  // endpoints accept the same body shape and stream different
  // binaries back: ``render-pdf`` for a real vector PDF (WeasyPrint)
  // and ``render-xlsx`` for a .xlsx workbook (openpyxl). Keep both
  // entries paired so anyone adding a third format puts it next to
  // its siblings instead of scattering them across the file.
  apiNeoDocumentRenderPdf: `/patient-centric-app-v2/neo/documents/render-pdf`,
  apiNeoDocumentRenderXlsx: `/patient-centric-app-v2/neo/documents/render-xlsx`,

  // Neo agent - files (Anthropic Files API uploads).
  // POST is multipart/form-data so the frontend uses raw fetch
  // (APIProvider.POST is JSON-only).
  apiNeoFiles: `/patient-centric-app-v2/neo/files`,
  apiNeoFile: `/patient-centric-app-v2/neo/files/{neo_file_id}`,
} as const;

export type IAPIRoutes = typeof APIRoutes;
